export default __webpack_public_path__ + "static/media/brasil-flag.100516bc.svg";